import {BOTTOMITEMS, CHOOSENMOVIES, CUSTOMITEMS, MOVIE} from '../../../constants/itemTypes'
import Translation from '../../Translation/cont/Translation'
import ListItemMovieNewspaperContainer from '../../DragAndDropItems/cont/ListItemMovieNewspaperContainer'
import ListItemBottomItemNewspaperContainer from '../../DragAndDropItems/cont/ListItemBottomItemNewspaperContainer'

const NewspaperDropSwitch = ({
    itemId,
    itemData,
    basicUrl,
    isSelected=false,
    canEdit,
    dataType,
    cinemaId,
    canDelete=false,
    deleteItem=false
}) => {
    if(!itemData) {
        return ''
    }

    const { id, type } = itemData
    const pathnameEdit =  canEdit ? `${basicUrl}/${type}/${id}` : false
    const onDeleteItem = canDelete && deleteItem ? () => deleteItem(dataType, itemId) : false

    return (
        <div>
            {MOVIE === type ? (
                <ListItemMovieNewspaperContainer
                    itemType={type}
                    itemData={itemData}
                    cinemaId={cinemaId}
                    isSelected={isSelected}
                    onDelete={onDeleteItem}
                    />
            ) : CUSTOMITEMS === type ? (
                <ListItemBottomItemNewspaperContainer
                    textKey='name'
                    itemType={type}
                    itemData={itemData}
                    isSelected={isSelected}
                    pathnameEdit={pathnameEdit}
                    onDelete={onDeleteItem}
                /> 
            ): ('')}
         </div>
    )
}

export default NewspaperDropSwitch